const DEFAULT_STORE_LOCALE = 'en-GB'

const normaliseLocale = (locale) => {
  if (typeof locale !== 'string') {
    return ''
  }

  return locale.trim().replace(/_/g, '-').toLowerCase()
}

const resolveNormalisedLangCode = (locale) => {
  const normalisedCode = normaliseLocale(locale || DEFAULT_STORE_LOCALE).split('-')[0]

  return normalisedCode
}

const applyI18nLocale = async ({ app, locale }) => {
  await app.i18n.setLocale(locale)
}

export default ({ app, store }) => {
  if (!app?.i18n || !store) {
    return
  }

  const initialLocale = resolveNormalisedLangCode(store.getters?.locale)
  applyI18nLocale({ app, locale: initialLocale })

  /*
   * Vuex → i18n
   */
  store.watch(
    (state) => state.locale,
    async (locale) => {
      const resolved = resolveNormalisedLangCode(locale)

      await applyI18nLocale({ app, locale: resolved })
    }
  )
}
